// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "RewardDetailsRowMobile__regular__8tj-a";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const pending = "RewardDetailsRowMobile__pending__cyhyg";
export const confirmed = "RewardDetailsRowMobile__confirmed__5dQhk";
export const earned = "RewardDetailsRowMobile__earned__v6cLD";
export const expired = "RewardDetailsRowMobile__expired__vAyNt";
export const description = "RewardDetailsRowMobile__description__avaHU";
export const rowFooter = "RewardDetailsRowMobile__rowFooter__ZTFHV";
export const statusWrapper = "RewardDetailsRowMobile__statusWrapper__xQERK";
export const progressWrapper = "RewardDetailsRowMobile__progressWrapper__oaLqd";
export const statusCopyWrapper = "RewardDetailsRowMobile__statusCopyWrapper__0T0Tp";
export const date = "RewardDetailsRowMobile__date__QE7rr";
export const amount = "RewardDetailsRowMobile__amount__Z1f5D";
export const buy = "RewardDetailsRowMobile__buy__E0iJa";
export const sell = "RewardDetailsRowMobile__sell__Rm++d";